import { OrganizationForm } from '../OrganizationForm';

export const OrganizationEdit: React.FC = () => <OrganizationForm />;
